Vue.component("create-mailbox", {

    props: ["previousUrl", "mailboxDomain"],

    data () {
        return {
            form: new AppForm({alias: "", name: ""})
        };
    },

    computed: {
        formattedAliasFromName () {
            if (this.form && this.form.alias !== undefined && this.form.name !== undefined && this.form.name.length > 0) {
                return (this.form.name.toLowerCase().trim()).replaceAll(" ", "");
            }
            return "";
        }
    },

    watch: {
        "form.name": function (newValue) {
            if (this.form.alias !== undefined) {
                this.form.alias = this.formattedAliasFromName;
            }
        },
    },

    methods: {
        createMailbox () {
            if (!this.form.alias){
                this.form.setErrors({email: ['Address is a required field']})
            }
            this.form.email = this.form.alias + "@" + this.mailboxDomain;
            App.post("/settings/mailboxes/store", this.form)
            .then((response) => {
                Bus.$emit("mailbox-created");
                window.toastr.success("Mailbox Created!");
                window.location = response.redirect;
            });
        },
    },

});
